// 注目ワードの開閉
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll(
    '.menu-drawer__inner, .filter-item.keyword'
  );

  containers.forEach((container) => {
    const input = container.querySelector(
      '.search-box input'
    );

    const keywords = container.querySelector(
      '.sidebar__search-keywords'
    );

    if (!input || !keywords) return;

    input.addEventListener('focus', () => {
      keywords.classList.add('is-active');
    });

    input.addEventListener('click', () => {
      keywords.classList.add('is-active');
    });
  });
});